/**
 * src/pages/Scheduler.jsx
 * Detalle de los jobs programados (APScheduler) con la config por cliente.
 */
import { useNavigate } from 'react-router-dom'
import { Header } from '../components/layout/Header'
import { Card, KpiCard } from '../components/ui/Card'
import { Badge, RESULTADO_COLOR } from '../components/ui/Badge'
import { Table } from '../components/ui/Table'
import { useSchedulerDetalle } from '../hooks/useAdminPanel'

function fmtFecha(iso) {
  if (!iso) return '—'
  return new Date(iso).toLocaleString('es-CL', {
    day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit',
  })
}

const COLUMNS = [
  { key: 'job_id', label: 'Job', mono: true, nowrap: true },
  {
    key: 'cliente_nombre', label: 'Cliente',
    render: (v, row) => v
      ? <span>{v} <span style={{ color: 'var(--color-text-3)', fontFamily: 'var(--font-mono)', fontSize: '11px' }}>{row.cliente_id}</span></span>
      : <Badge color="gray">sistema</Badge>,
  },
  { key: 'tipo', label: 'Tipo', mono: true, width: '90px' },
  { key: 'frecuencia', label: 'Frecuencia', mono: true, width: '100px', render: v => v || '—' },
  { key: 'proximo_run', label: 'Próximo run', mono: true, nowrap: true, render: fmtFecha },
  { key: 'ultimo_run', label: 'Último run', mono: true, nowrap: true, render: fmtFecha },
  {
    key: 'ultimo_resultado', label: 'Resultado', width: '100px',
    render: v => v
      ? <Badge color={RESULTADO_COLOR[v] || 'gray'}>{v}</Badge>
      : <span style={{ color: 'var(--color-text-3)' }}>—</span>,
  },
]

export default function Scheduler() {
  const navigate = useNavigate()
  const { data, isLoading } = useSchedulerDetalle()
  const jobs = data?.jobs || []
  const pipeline = jobs.filter(j => j.cliente_id)

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <Header title="Scheduler" subtitle="Trabajos programados y su estado por cliente" />

      <div style={{ flex: 1, overflow: 'auto', padding: '24px 28px' }}>
        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '14px',
          marginBottom: '24px',
        }}>
          <KpiCard label="SCHEDULER" value={data ? (data.scheduler_activo ? 'ON' : 'OFF') : '—'}
                   color={data?.scheduler_activo ? 'var(--color-ok)' : 'var(--color-error)'} />
          <KpiCard label="JOBS DE PIPELINE" value={isLoading ? '—' : pipeline.length}
                   sub="uno por cliente y tipo" />
          <KpiCard label="JOBS DE SISTEMA" value={isLoading ? '—' : jobs.length - pipeline.length}
                   sub="vigía de salud, etc." color="var(--color-text-3)" />
        </div>

        <Card title="Jobs programados" subtitle="Ordenados por próxima ejecución" padding="0">
          <Table
            columns={COLUMNS}
            data={jobs}
            loading={isLoading}
            emptyMessage="Sin jobs programados"
            onRowClick={row => row.cliente_id && navigate(`/scraping/${row.cliente_id}`)}
          />
        </Card>
      </div>
    </div>
  )
}
